define('base/router',['require','exports','module','backbone','underscore'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      _ = require("underscore");

  function maybeApply(fn, ctx, args) {
    if (fn) {
      return fn.apply(ctx, args);
    }
  }

  function capitalize(str) {
    return str[0].toUpperCase().concat(str.slice(1));
  }

  module.exports = Backbone.Router.extend({
    route: function(route, name, callback) {
      if (_.isString(name)) {
        callback = _.bind(function() {
          var data = maybeApply(this.beforeAll, this, arguments),
              args = _.without(arguments, null);
          data = maybeApply(this["before" + capitalize(name)], this, [].concat(args, data)) || data;
          data = maybeApply(this[name], this, [].concat(args, data)) || data;
          data = maybeApply(this["after" + capitalize(name)], this, [].concat(args, data)) || data;
          maybeApply(this.afterAll, this, [].concat(args, data));
        }, this);
      }
      return module.exports.__super__.route.call(this, route, name, callback);
    }
  });

});

